import { createAction } from 'redux-actions';

export const onChangeQuery = createAction('RO_ITEM_ON_CHANGE_QUERY');

export const onClearQuery = createAction('RO_ITEM_ON_CLEAR_QUERY');
